import settings from "./settings";

export const SETTINGS_NAMESPACE = "settings";
export const fromSettings = name => `${SETTINGS_NAMESPACE}/${name}`;

export default settings;
